import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'CraneOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crane-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 21h6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 21v-12"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 5v-2l-1 1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 6l-3 3h6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13 9h8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 3l10 6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 9v4a2 2 0 0 1 2 2m-2 2a2 2 0 0 1 -2 -2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};